





























































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { FinancialReportData } from "@/entities";
import { AppConstants as _app } from "@/shared/app.constants";
import FormattedNumber from '@/components/common/Inputs/FormattedNumber.vue';
import TableComponent from './Components/PersonnelTable.vue';
import ImportLog from '@/components/common/ValidationMessage/ImportLog.vue';
import HeaderInfo from '../../ExpansionPanel/FinExpansionPanel.vue';
import NavButtons from '@/components/common/Buttons/NavButtons.vue';
import { Locales } from "@/i18n/locales";

const namespace: string = "financialReport";
@Component({
  components: {
    TableComponent,
    FormattedNumber,
    HeaderInfo,
    NavButtons,
    ImportLog,
    SeriesTable: () => import('@/components/common/SeriesTable/Series.vue')
  }
})
export default class SummaryTableComponent extends Vue {
  // @State(namespace) financialReport!: FinancialReportData;
  @Getter('selectedReport', {namespace}) report: any;
  @Getter('grantInfo', {namespace}) grantInfo: any;
  @Action('getAppBudgetForGrant', {namespace}) getAppBudgetForGrant: any;
  @Prop() financialReportSections: any;
  @Prop() validations: any
  @Prop() model: any;
  @Prop() readonly: any;
  @Prop() schema: any;
  @Prop() formOptions: any;
  @Prop() isDirty: any;
  @Prop() workFlowItems: any;
  @Prop() preValidation: any;
  @Prop() entity: any;
  @Prop() currency: string;
  @Prop() enableButton: any;
  @Prop() applicationBudgetForGrant: any;
  @Prop() financialReport: any;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  mounted() {
    let params =  {
      id : this.financialReport.grantData.grantId,
      financialReportId : this.financialReport.selectedReport.FinancialReportId,
      period : this.financialReport.selectedReport.Title
    }
    this.getAppBudgetForGrant(params);
  }

  get template() {
      if(this.schema && this.schema.properties && this.schema.properties.summary) {
          return this.schema.properties.summary
      }
  }
  
  get dataModel() {
    return this.applicationBudgetForGrant;
  }

  get header() {
    if(this.schema && this.schema.properties && this.schema.properties.personnelHeaders) {
      return this.schema.properties.personnelHeaders.items
    }
  }

  get options(): any {
      return {
      disableAll: true,
      currency: this.currency || 'EUR',
      locale: this.defaultLocale
      }
  }

  get currencyList() {
    return this.financialReport.currencyList;
  }

  get budget() {
    let obj: any = {};
    if (
      this.financialReport.grantData &&
      this.financialReport.grantData.applicationBudget
    ) {
      obj = this.financialReport.grantData.applicationBudget;
    }
    return obj;
  }

  get budgetCategories() {
    return this.financialReport.categories;
  }
}
